import * as React from 'react';
export const VitalLoader = () => {
    return (React.createElement("div", { className: "tailwind" },
        React.createElement("div", { className: "container p-8 flex flex-row justify-center items-center" },
            React.createElement("div", { className: "relative h-8 w-8" },
                React.createElement("img", { className: "animate-ping absolute h-full w-full", src: "https://cdn.shopify.com/s/files/1/2074/9385/files/vital-shield_200x.png?v=1457225199074094420", alt: "Vital Proteins Logo" }),
                React.createElement("img", { className: "relative h-8 w-8", src: "https://cdn.shopify.com/s/files/1/2074/9385/files/vital-shield_200x.png?v=1457225199074094420", alt: "Vital Proteins Logo" })))));
};
